import { createSelector } from 'reselect';

const selectWScoreWheel = state => state.get('wscoreWheel');

export const selectWScoreWheelActive = () =>
  createSelector(selectWScoreWheel, data => data.get('active'));
